import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const watchListApi = createApi({
  reducerPath: reducerPaths.watchListApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    fetchWatchListCars: builder.query({
      query: ({ params }) => ({
        method: "GET",
        url: `/myGarage/Dealer/WatchList`,
        params: params || {}
      }),
    }),
  }),
});

export const {
  useLazyFetchWatchListCarsQuery
} = watchListApi;
